module.exports = __webpack_public_path__ + "img/yml.64f1b509.png";